import LOGO from '@/assets/images/logo/weee-simple-gray.svg';
import useTranslation from 'next-translate/useTranslation';

const InviteeFooter = () => {
  const { t } = useTranslation('referral');
  return (
    <div className="w-full bg-shade-cool-light-1 text-center">
      <div className="pt-7">
        <div className="enki-heading-2xl text-primary-1 py-2.5">{t('referral_ready_explore')}</div>
        <div className="mt-3 enki-body-base-medium text-surface-100-fg-default">
          {t('referral_let_taste_difference')}
        </div>
      </div>
      <div className="leading-[0] mt-32">
        <img src={LOGO} alt="logo" />
        <div className="py-4 enki-body-sm-medium text-surface-100-fg-minor">©️ 2025 Weee! Inc.</div>
      </div>
    </div>
  );
};

export default InviteeFooter;
